"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointSelector = breakpointSelector;

var _beaconTheme = _interopRequireDefault(require("@braze/beacon-theme"));

var _escapeCss = require("../../escapeCss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function breakpointSelector(props, size) {
  var _props$theme, _props$theme2, _props$theme2$breakpo;

  if (!((_props$theme = props.theme) !== null && _props$theme !== void 0 && _props$theme.breakpoints)) {
    // eslint-disable-next-line no-console
    console.debug("WARNING: no Beacon theme provider found in React component tree");
  }

  return (0, _escapeCss.escapeCss)(((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$breakpo = _props$theme2.breakpoints) === null || _props$theme2$breakpo === void 0 ? void 0 : _props$theme2$breakpo[size]) || _beaconTheme["default"].breakpoints[size]);
}